import { Accordion } from '../../../../../components/general/accordion';
import GroupsIcon from '@mui/icons-material/Groups';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { PqrStrategicAllyProps } from './props';
import { usePqrStrategicAlly } from './hook';

export const PqrStrategicAlly = ({ strategicAlly }: PqrStrategicAllyProps) => {
    const { formik } = usePqrStrategicAlly(strategicAlly);

    return (
        <Accordion
            title="ALIADO ESTRATÉGICO"
            icon={<GroupsIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="Aliado estratégico"
                        name="strategicAlly"
                        size="small"
                        value={formik.values.strategicAlly}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
